import { Container } from 'react-bootstrap';
import { ReactNode } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import SkipLinks from '../Utilities/skipLinks';
import BackToTopButton from '../Utilities/backToTopButton';
import RouteAccessibleNavigation from '../Utilities/routeAccessibleNavigation';
import RouteChangeScrollTop from '../Utilities/routeChangeScrollTop';

interface LayoutProps {
    children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => (
    <>
        <RouteAccessibleNavigation />
        <RouteChangeScrollTop />
        <SkipLinks />
        <Header />
        <Container fluid id='main' role='main' className='px-0' tabIndex={-1}>
            {children}
        </Container>
        <Footer />
        <BackToTopButton />
    </>
);

export default Layout;
